var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{staticClass:"status",class:_setup.cls,attrs:{"small":"","xlabel":"","outlined":""}},[(_vm.$slots.prefix)?_c('span',{staticClass:"prefix"},[_vm._t("prefix")],2):_vm._e(),_vm._t("default",function(){return [_vm._v("a")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }